<div class="p-5 h-full w-full border border-solid border-[#C8C8CD] rounded-[8px]">
  <div class="flex flex-row items-center justify-between mb-[5px]">
    @if (entityBacked()) {
      <h4>Backing is ON</h4>
    } @else {
      <h4>Back this {{ formatEntityType(entityType) }}</h4>
    }
    <ark-ui-switch
      [checked]="entityBacked()"
      (selectionChanged)="onSwitchChange($any($event))"
    ></ark-ui-switch>
  </div>

  <div class="text-[12px] leading-[20px]">
    @if (entityBacked()) {
      <div>
        You are now backing this {{ formatEntityType(entityType) }}.
        @if (entityType === 'thinktank') {
          Backing a {{ formatEntityType(entityType) }} means using your voting power to show confidence in its potential for real-world impact. It’s more than a like. It’s a meaningful pledge of support for the problem being addressed, the solutions being explored, and the community’s ability to turn ideas into action.
        } @else {
          Backing a {{ formatEntityType(entityType) }} means a commitment to show your confidence in its success and real world impact. It’s more than a like; it’s a pledge of support.
        }
      </div>
    } @else {
      <div>
        @if (entityType === 'thinktank') {
          Backing a {{ formatEntityType(entityType) }} means using your voting power to show confidence in its potential for real-world impact. It’s more than a like. It’s a meaningful pledge of support for the problem being addressed, the solutions being explored, and the community’s ability to turn ideas into action.
        } @else {
          Backing a {{ formatEntityType(entityType) }} means using your voting power to show confidence in its potential for real-world impact. It’s more than a like. It’s a meaningful pledge of support for the problem being addressed.
        }
      </div>
    }
  </div>
</div>
